var map = {
	"./15s_left.svg": 32140,
	"./15s_right.svg": 49107,
	"./AF_actived.svg": 56485,
	"./AF_normal.svg": 29280,
	"./Arrest_S.svg": 16194,
	"./ArrowDown.svg": 83518,
	"./ArrowFirst.svg": 13648,
	"./ArrowLast.svg": 58570,
	"./ArrowLeft-sq.svg": 58670,
	"./ArrowRight-sq.svg": 15149,
	"./ArrowTop.svg": 18503,
	"./Arrow_down.svg": 73529,
	"./Ask_S.svg": 8536,
	"./Back.svg": 94634,
	"./Camera.svg": 24102,
	"./CarPlate.svg": 92977,
	"./CarPlate_yellow.svg": 49252,
	"./Car_L.svg": 46866,
	"./Car_L_yellow.svg": 76429,
	"./Component115-13.svg": 17640,
	"./Copy.svg": 53256,
	"./Crop.svg": 26393,
	"./DB.svg": 32437,
	"./Dots_LightYellow.svg": 88294,
	"./DownloadCenter.svg": 75996,
	"./Drop.svg": 75912,
	"./Engineer.svg": 35924,
	"./Error-gray.svg": 14133,
	"./Error.svg": 70559,
	"./EyeClose.svg": 91334,
	"./EyeClose2.svg": 61544,
	"./EyeOpen.svg": 83130,
	"./EyeOpen2.svg": 72324,
	"./FR.svg": 34095,
	"./FancyMapIcon.svg": 32903,
	"./Female.svg": 16055,
	"./File.svg": 2869,
	"./FileType.svg": 55085,
	"./GenderUnknow.svg": 81148,
	"./Group-1322.svg": 54409,
	"./Group-1333.svg": 5467,
	"./Group-1355.svg": 62839,
	"./Group-977.svg": 14504,
	"./Group-yellow.svg": 17865,
	"./Group.svg": 19192,
	"./IR.svg": 56538,
	"./IR_auto.svg": 26216,
	"./IR_no.svg": 74072,
	"./Icon-feather-search.svg": 32779,
	"./Info_24.svg": 13628,
	"./Investigate-h.svg": 9143,
	"./Investigate.svg": 50672,
	"./LPR.svg": 50447,
	"./Male.svg": 22820,
	"./Map.svg": 98967,
	"./Motor_L.svg": 77007,
	"./Motor_L_yellow.svg": 55170,
	"./Moving-1.svg": 59075,
	"./Moving.svg": 45017,
	"./Note_S.svg": 15409,
	"./OR.svg": 31656,
	"./OrPin_Big.svg": 96562,
	"./PTZ.svg": 26436,
	"./Patrol.svg": 62109,
	"./RightArrow.svg": 16158,
	"./Role-Pen.svg": 85937,
	"./SearchCar_S.svg": 77729,
	"./Star.svg": 56367,
	"./ThirdGender.svg": 46217,
	"./TrashCan.svg": 75691,
	"./Type.svg": 77123,
	"./Union-4.svg": 20251,
	"./VideoPin_Big.svg": 15866,
	"./VideoTime.svg": 10227,
	"./WarningArea.svg": 91610,
	"./WebMapCenter_Locked.svg": 53993,
	"./ZoomIn.svg": 48371,
	"./account-ab.svg": 48352,
	"./account-close.svg": 11847,
	"./account-edit.svg": 80857,
	"./account-email.svg": 21023,
	"./account-logout.svg": 76963,
	"./account-map.svg": 93349,
	"./account-name.svg": 41524,
	"./account-phone.svg": 86575,
	"./account-psd.svg": 46126,
	"./account-role.svg": 4353,
	"./account-two-factor.svg": 95835,
	"./account-user.svg": 84599,
	"./account.svg": 12064,
	"./account_detail_2fa.svg": 30652,
	"./account_detail_category.svg": 28943,
	"./account_detail_lang.svg": 58571,
	"./account_detail_name.svg": 15406,
	"./account_detail_private.svg": 81824,
	"./account_detail_public.svg": 4948,
	"./account_detail_role.svg": 73183,
	"./account_detail_source.svg": 11428,
	"./account_detail_tz.svg": 96069,
	"./account_detail_video_title.svg": 12595,
	"./age.svg": 64896,
	"./ai-note.svg": 7066,
	"./aim.svg": 15278,
	"./all-s.svg": 1588,
	"./all.svg": 63672,
	"./android_icon.svg": 85960,
	"./arrest.svg": 82900,
	"./arrow-back-hover.svg": 35407,
	"./arrow-back.svg": 69566,
	"./arrow-down.svg": 31759,
	"./arrow-first.svg": 28443,
	"./arrow-last.svg": 58707,
	"./arrow-left.svg": 65648,
	"./arrow-next-hover.svg": 61741,
	"./arrow-next.svg": 11016,
	"./arrow-prev-hover.svg": 79429,
	"./arrow-prev.svg": 98192,
	"./arrow-right.svg": 76415,
	"./arrow.svg": 57190,
	"./arrowLeft.svg": 72213,
	"./arrowRight.svg": 45144,
	"./arrowTopBtm.svg": 63022,
	"./arrow_left_double.svg": 74626,
	"./arrow_right_double.svg": 66363,
	"./atention.svg": 18267,
	"./banner_dashboard.svg": 7624,
	"./banner_login.svg": 52099,
	"./bell-solid.svg": 85482,
	"./bicycle.svg": 21194,
	"./blueCar.svg": 88095,
	"./box-camera_focus_lock-gps.svg": 51044,
	"./box-camera_focus_new-gps.svg": 94815,
	"./box-camera_focus_off-line.svg": 36332,
	"./box-camera_focus_old-gps.svg": 70298,
	"./box-camera_lock-gps.svg": 25667,
	"./box-camera_new-gps.svg": 13330,
	"./box-camera_off-line.svg": 95483,
	"./box-camera_old-gps.svg": 87531,
	"./box-camera_sos.svg": 7866,
	"./brush.svg": 64205,
	"./bus.svg": 41839,
	"./bwc_focus_lock-gps.svg": 56549,
	"./bwc_focus_new-gps.svg": 28628,
	"./bwc_focus_off-line.svg": 86217,
	"./bwc_focus_old-gps.svg": 24521,
	"./bwc_focus_sos.svg": 4056,
	"./bwc_lock-gps.svg": 49166,
	"./bwc_new-gps.svg": 79569,
	"./bwc_off-line.svg": 65362,
	"./bwc_old-gps.svg": 11496,
	"./bwc_sos.svg": 99149,
	"./call_mute.svg": 59165,
	"./calling-answer.svg": 9908,
	"./calling-glist-dn.svg": 46272,
	"./calling-glist-up.svg": 17521,
	"./calling-mute.svg": 37841,
	"./calling-off.svg": 237,
	"./calling-search-btn.svg": 9093,
	"./calling-unmute.svg": 12400,
	"./camera1-lg.svg": 31335,
	"./camera1-m.svg": 88041,
	"./camera2-lg.svg": 15302,
	"./camera2-m.svg": 11026,
	"./car-m.svg": 36205,
	"./car-note.svg": 69508,
	"./car-solid-h.svg": 93974,
	"./car-solid.svg": 14797,
	"./car.svg": 62575,
	"./caret-down-solid.svg": 5827,
	"./caret-up-solid.svg": 83776,
	"./carplate-scan.svg": 35229,
	"./chasing.svg": 16422,
	"./chasing_s.svg": 34100,
	"./chat.svg": 98701,
	"./check-box-outline-blank.svg": 85849,
	"./check-square-enabled.svg": 85511,
	"./check-square.svg": 4723,
	"./check.svg": 82497,
	"./checkbox-click.svg": 93815,
	"./checkbox-null.svg": 33578,
	"./checkbox-white-square.svg": 25716,
	"./checkbox-yellow-checked.svg": 7397,
	"./checkbox-yellow-minus.svg": 1998,
	"./checkbox.svg": 40548,
	"./checked-gray.svg": 24958,
	"./checked-green.svg": 30484,
	"./checked-white.svg": 51882,
	"./checked.svg": 49406,
	"./circle.svg": 77183,
	"./clear-gray.svg": 85082,
	"./clear-yellow.svg": 7943,
	"./clear.svg": 37938,
	"./clock-solid.svg": 23305,
	"./clock.svg": 92075,
	"./close-focus.svg": 78598,
	"./close.svg": 35837,
	"./closeWin.svg": 37877,
	"./close_aibox.svg": 44249,
	"./cloud.svg": 81326,
	"./co-find-h.svg": 84416,
	"./co-find.svg": 92783,
	"./cofind.svg": 85480,
	"./collapse.svg": 40726,
	"./common_focus_lock-gps.svg": 43382,
	"./common_focus_new-gps.svg": 8745,
	"./common_focus_off-line.svg": 23754,
	"./common_focus_old-gps.svg": 79408,
	"./common_focus_sos.svg": 31061,
	"./common_lock-gps.svg": 1065,
	"./common_new-gps.svg": 47128,
	"./common_off-line.svg": 1013,
	"./common_old-gps.svg": 85213,
	"./common_sos.svg": 3660,
	"./db-info.svg": 53658,
	"./db_s.svg": 95195,
	"./db_s_1.svg": 59275,
	"./def-image.svg": 58868,
	"./developer.svg": 14931,
	"./device-list.svg": 73358,
	"./device-search.svg": 43362,
	"./device-type.svg": 12530,
	"./device.svg": 10781,
	"./device_model_0.svg": 2590,
	"./device_model_0_disable.svg": 13987,
	"./device_model_0_locked.svg": 18923,
	"./device_model_10.svg": 58829,
	"./device_model_100.svg": 52311,
	"./device_model_100_disable.svg": 54058,
	"./device_model_100_locked.svg": 75688,
	"./device_model_10_disable.svg": 16220,
	"./device_model_10_locked.svg": 93858,
	"./device_model_110.svg": 51188,
	"./device_model_110_disable.svg": 21501,
	"./device_model_110_locked.svg": 93901,
	"./device_model_120.svg": 7389,
	"./device_model_120_disable.svg": 1068,
	"./device_model_120_locked.svg": 66610,
	"./device_model_130.svg": 26370,
	"./device_model_130_disable.svg": 49191,
	"./device_model_130_locked.svg": 4447,
	"./device_model_131.svg": 40595,
	"./device_model_131_disable.svg": 20070,
	"./device_model_131_locked.svg": 86404,
	"./device_model_140.svg": 43347,
	"./device_model_140_disable.svg": 74182,
	"./device_model_140_locked.svg": 90660,
	"./device_model_20.svg": 74308,
	"./device_model_200.svg": 65916,
	"./device_model_2000.svg": 85732,
	"./device_model_2000_disable.svg": 77677,
	"./device_model_2000_locked.svg": 47453,
	"./device_model_200_disable.svg": 51989,
	"./device_model_200_locked.svg": 89989,
	"./device_model_20_disable.svg": 95341,
	"./device_model_20_locked.svg": 3261,
	"./device_model_2100.svg": 27645,
	"./device_model_2100_disable.svg": 84908,
	"./device_model_2100_locked.svg": 93458,
	"./device_model_2200.svg": 92182,
	"./device_model_2200_disable.svg": 90539,
	"./device_model_2200_locked.svg": 93299,
	"./device_model_30.svg": 50311,
	"./device_model_30_disable.svg": 3866,
	"./device_model_30_locked.svg": 24216,
	"./device_model_40.svg": 13838,
	"./device_model_4000.svg": 33790,
	"./device_model_4000_disable.svg": 59523,
	"./device_model_4000_locked.svg": 94955,
	"./device_model_40_disable.svg": 84563,
	"./device_model_40_locked.svg": 56667,
	"./device_model_50.svg": 53785,
	"./device_model_500.svg": 57451,
	"./device_model_500_disable.svg": 83854,
	"./device_model_500_locked.svg": 68908,
	"./device_model_50_disable.svg": 14168,
	"./device_model_50_locked.svg": 10238,
	"./device_type_PTZ.svg": 3419,
	"./dialogBrush.svg": 13457,
	"./dialogCar.svg": 13179,
	"./dialogClock.svg": 25463,
	"./dialogLocation.svg": 89890,
	"./dialogTag.svg": 43793,
	"./dice.svg": 49246,
	"./ditsAnimation.svg": 31033,
	"./dome-camera_focus_lock-gps.svg": 51756,
	"./dome-camera_focus_new-gps.svg": 5879,
	"./dome-camera_focus_off-line.svg": 29316,
	"./dome-camera_focus_old-gps.svg": 75106,
	"./dome-camera_lock-gps.svg": 76747,
	"./dome-camera_new-gps.svg": 88490,
	"./dome-camera_off-line.svg": 5875,
	"./dome-camera_old-gps.svg": 20531,
	"./dome-camera_sos.svg": 42498,
	"./double-bottom.svg": 716,
	"./double-left.svg": 36982,
	"./double-right.svg": 56789,
	"./double-top.svg": 91990,
	"./download-video.svg": 88513,
	"./download.svg": 91303,
	"./earth.svg": 36665,
	"./edit-name.svg": 36905,
	"./enable-item.svg": 62210,
	"./erase-white.svg": 54339,
	"./error-info.svg": 84452,
	"./event-search-hover.svg": 28039,
	"./event-search.svg": 15846,
	"./face-note.svg": 46525,
	"./face-scan.svg": 77218,
	"./face_0.svg": 54509,
	"./face_1.svg": 55564,
	"./failed.svg": 61728,
	"./far-focus.svg": 81729,
	"./feather-download-null.svg": 55898,
	"./feather-download.svg": 28181,
	"./feather-search-gray.svg": 13227,
	"./feather-search-hover.svg": 74900,
	"./feather-search-w.svg": 52173,
	"./feather-search.svg": 67721,
	"./feather-trash-2.svg": 86396,
	"./feather-trash.svg": 55069,
	"./file_download.svg": 23736,
	"./filter.svg": 87985,
	"./flip.svg": 60670,
	"./folder-close.svg": 55448,
	"./folder.svg": 30811,
	"./fr-new-photo.svg": 61437,
	"./fr_feature_1.svg": 63988,
	"./fr_feature_2.svg": 51847,
	"./fr_feature_3.svg": 64726,
	"./fr_feature_4.svg": 39961,
	"./fr_feature_5.svg": 32040,
	"./fr_gender.svg": 11501,
	"./fr_gender_0.svg": 36400,
	"./fr_gender_1.svg": 71937,
	"./fr_gender_2.svg": 62450,
	"./fr_job.svg": 69963,
	"./fr_sample_fail_1.svg": 25307,
	"./fr_sample_fail_2.svg": 43944,
	"./fr_sample_fail_3.svg": 51865,
	"./fr_sample_ok.svg": 79417,
	"./fullscreen.svg": 25276,
	"./gender-na.svg": 28454,
	"./gps.svg": 37405,
	"./graduation-cap.svg": 52936,
	"./green-phone.svg": 49775,
	"./grid.svg": 33591,
	"./group-call.svg": 83405,
	"./group-calling-bgon.svg": 33982,
	"./group-calling-click.svg": 80308,
	"./group-calling-off.svg": 85211,
	"./group-calling-on.svg": 60127,
	"./group-error.svg": 55821,
	"./group-icon.svg": 61594,
	"./groupPhone.svg": 44180,
	"./hand-off.svg": 98592,
	"./hide.svg": 32243,
	"./high_sense.svg": 89016,
	"./high_sense_no.svg": 89526,
	"./history-erase.svg": 41696,
	"./history-filter.svg": 77892,
	"./history.svg": 13185,
	"./home-hover.svg": 41007,
	"./home.svg": 74174,
	"./house.svg": 58901,
	"./icon-play.svg": 40355,
	"./id-card.svg": 62151,
	"./id-m.svg": 36510,
	"./id.svg": 11508,
	"./image.svg": 83922,
	"./info-solid.svg": 90161,
	"./info.svg": 36947,
	"./ios_icon.svg": 78066,
	"./join-call.svg": 97144,
	"./joystick.svg": 66377,
	"./key.svg": 97000,
	"./kind.svg": 18157,
	"./language.svg": 8997,
	"./last-disable.svg": 60052,
	"./last.svg": 12687,
	"./layer.svg": 31158,
	"./lb-account-hover.svg": 49082,
	"./lb-account.svg": 28755,
	"./lb-dashboard-hover.svg": 48723,
	"./lb-dashboard.svg": 95634,
	"./lb-history-hover.svg": 98491,
	"./lb-history.svg": 39562,
	"./lb-log-hover.svg": 4289,
	"./lb-log.svg": 54860,
	"./lb-recognition-hover.svg": 88126,
	"./lb-recognition.svg": 8055,
	"./lb-system-hover.svg": 44560,
	"./lb-system.svg": 49493,
	"./leftMenuToggle.svg": 72149,
	"./line.svg": 38361,
	"./link.svg": 31119,
	"./link_16_black.svg": 59775,
	"./live.svg": 13329,
	"./liveVideo-gray.svg": 29346,
	"./liveVideo.svg": 95210,
	"./loading.svg": 67649,
	"./loading_80.svg": 5116,
	"./lock-gray.svg": 35042,
	"./lock.svg": 45482,
	"./login-hide.svg": 25683,
	"./login-next-btn.svg": 64987,
	"./login-show.svg": 78600,
	"./logo.svg": 26962,
	"./map-center.svg": 41187,
	"./map_device_model_0_focus_lock-gps.svg": 54811,
	"./map_device_model_0_focus_new-gps.svg": 24570,
	"./map_device_model_0_focus_off-line.svg": 81699,
	"./map_device_model_0_focus_old-gps.svg": 6403,
	"./map_device_model_0_focus_sos.svg": 31474,
	"./map_device_model_0_lock-gps.svg": 59224,
	"./map_device_model_0_new-gps.svg": 33267,
	"./map_device_model_0_off-line.svg": 31080,
	"./map_device_model_0_old-gps.svg": 14606,
	"./map_device_model_0_sos.svg": 99043,
	"./map_device_model_100_focus_lock-gps.svg": 16204,
	"./map_device_model_100_focus_new-gps.svg": 85175,
	"./map_device_model_100_focus_off-line.svg": 77412,
	"./map_device_model_100_focus_old-gps.svg": 54402,
	"./map_device_model_100_lock-gps.svg": 29579,
	"./map_device_model_100_new-gps.svg": 67562,
	"./map_device_model_100_off-line.svg": 42355,
	"./map_device_model_100_old-gps.svg": 99603,
	"./map_device_model_10_focus_lock-gps.svg": 2976,
	"./map_device_model_10_focus_new-gps.svg": 1611,
	"./map_device_model_10_focus_off-line.svg": 27296,
	"./map_device_model_10_focus_old-gps.svg": 46166,
	"./map_device_model_10_lock-gps.svg": 89455,
	"./map_device_model_10_new-gps.svg": 40974,
	"./map_device_model_10_off-line.svg": 66687,
	"./map_device_model_10_old-gps.svg": 18471,
	"./map_device_model_110_focus_lock-gps.svg": 13661,
	"./map_device_model_110_focus_new-gps.svg": 32956,
	"./map_device_model_110_focus_off-line.svg": 53745,
	"./map_device_model_110_focus_old-gps.svg": 61633,
	"./map_device_model_110_lock-gps.svg": 38438,
	"./map_device_model_110_new-gps.svg": 17721,
	"./map_device_model_110_off-line.svg": 59386,
	"./map_device_model_110_old-gps.svg": 59488,
	"./map_device_model_120_focus_lock-gps.svg": 24422,
	"./map_device_model_120_focus_new-gps.svg": 16121,
	"./map_device_model_120_focus_off-line.svg": 50682,
	"./map_device_model_120_focus_old-gps.svg": 30816,
	"./map_device_model_120_lock-gps.svg": 12281,
	"./map_device_model_120_new-gps.svg": 35336,
	"./map_device_model_120_off-line.svg": 23141,
	"./map_device_model_120_old-gps.svg": 55917,
	"./map_device_model_130_focus_lock-gps.svg": 85919,
	"./map_device_model_130_focus_new-gps.svg": 10462,
	"./map_device_model_130_focus_off-line.svg": 18607,
	"./map_device_model_130_focus_old-gps.svg": 49783,
	"./map_device_model_130_lock-gps.svg": 92636,
	"./map_device_model_130_new-gps.svg": 67207,
	"./map_device_model_130_off-line.svg": 39604,
	"./map_device_model_130_old-gps.svg": 20018,
	"./map_device_model_131_focus_lock-gps.svg": 37488,
	"./map_device_model_131_focus_new-gps.svg": 17467,
	"./map_device_model_131_focus_off-line.svg": 61552,
	"./map_device_model_131_focus_old-gps.svg": 83590,
	"./map_device_model_131_lock-gps.svg": 80415,
	"./map_device_model_131_new-gps.svg": 18974,
	"./map_device_model_131_off-line.svg": 95887,
	"./map_device_model_131_old-gps.svg": 42487,
	"./map_device_model_140_focus_lock-gps.svg": 16272,
	"./map_device_model_140_focus_new-gps.svg": 56219,
	"./map_device_model_140_focus_off-line.svg": 55024,
	"./map_device_model_140_focus_old-gps.svg": 57798,
	"./map_device_model_140_lock-gps.svg": 65919,
	"./map_device_model_140_new-gps.svg": 56190,
	"./map_device_model_140_off-line.svg": 98607,
	"./map_device_model_140_old-gps.svg": 79159,
	"./map_device_model_2000_focus_lock-gps.svg": 25867,
	"./map_device_model_2000_focus_new-gps.svg": 43178,
	"./map_device_model_2000_focus_off-line.svg": 5491,
	"./map_device_model_2000_focus_old-gps.svg": 12307,
	"./map_device_model_2000_focus_sos.svg": 70050,
	"./map_device_model_2000_lock-gps.svg": 60648,
	"./map_device_model_2000_new-gps.svg": 61699,
	"./map_device_model_2000_off-line.svg": 99448,
	"./map_device_model_2000_old-gps.svg": 73086,
	"./map_device_model_2000_sos.svg": 35347,
	"./map_device_model_200_focus_lock-gps.svg": 34265,
	"./map_device_model_200_focus_new-gps.svg": 12040,
	"./map_device_model_200_focus_off-line.svg": 25093,
	"./map_device_model_200_focus_old-gps.svg": 6765,
	"./map_device_model_200_focus_sos.svg": 98620,
	"./map_device_model_200_lock-gps.svg": 4210,
	"./map_device_model_200_new-gps.svg": 25157,
	"./map_device_model_200_off-line.svg": 7822,
	"./map_device_model_200_old-gps.svg": 16748,
	"./map_device_model_200_sos.svg": 80577,
	"./map_device_model_20_focus_lock-gps.svg": 21443,
	"./map_device_model_20_focus_new-gps.svg": 74482,
	"./map_device_model_20_focus_off-line.svg": 86395,
	"./map_device_model_20_focus_old-gps.svg": 58187,
	"./map_device_model_20_lock-gps.svg": 2080,
	"./map_device_model_20_new-gps.svg": 12363,
	"./map_device_model_20_off-line.svg": 21408,
	"./map_device_model_20_old-gps.svg": 43574,
	"./map_device_model_2100_focus_lock-gps.svg": 82132,
	"./map_device_model_2100_focus_new-gps.svg": 43119,
	"./map_device_model_2100_focus_off-line.svg": 1532,
	"./map_device_model_2100_focus_old-gps.svg": 38026,
	"./map_device_model_2100_focus_sos.svg": 86415,
	"./map_device_model_2100_lock-gps.svg": 5011,
	"./map_device_model_2100_new-gps.svg": 16994,
	"./map_device_model_2100_off-line.svg": 87723,
	"./map_device_model_2100_old-gps.svg": 31547,
	"./map_device_model_2100_sos.svg": 42858,
	"./map_device_model_2200_focus_lock-gps.svg": 63617,
	"./map_device_model_2200_focus_new-gps.svg": 64416,
	"./map_device_model_2200_focus_off-line.svg": 19325,
	"./map_device_model_2200_focus_old-gps.svg": 13461,
	"./map_device_model_2200_focus_sos.svg": 13156,
	"./map_device_model_2200_lock-gps.svg": 8122,
	"./map_device_model_2200_new-gps.svg": 77597,
	"./map_device_model_2200_off-line.svg": 49670,
	"./map_device_model_2200_old-gps.svg": 32180,
	"./map_device_model_2200_sos.svg": 98313,
	"./map_device_model_30_focus_lock-gps.svg": 39514,
	"./map_device_model_30_focus_new-gps.svg": 40381,
	"./map_device_model_30_focus_off-line.svg": 58854,
	"./map_device_model_30_focus_old-gps.svg": 77556,
	"./map_device_model_30_lock-gps.svg": 67997,
	"./map_device_model_30_new-gps.svg": 35836,
	"./map_device_model_30_off-line.svg": 56657,
	"./map_device_model_30_old-gps.svg": 33793,
	"./map_device_model_4000.svg": 2249,
	"./map_device_model_4000_focus.svg": 98852,
	"./map_device_model_4000_focus_lock-gps.svg": 46693,
	"./map_device_model_4000_focus_off-line.svg": 18185,
	"./map_device_model_4000_focus_old-gps.svg": 39977,
	"./map_device_model_4000_lock-gps.svg": 67438,
	"./map_device_model_4000_off-line.svg": 15314,
	"./map_device_model_4000_old-gps.svg": 89128,
	"./map_device_model_40_focus__new-gps.svg": 23567,
	"./map_device_model_40_focus_lock-gps.svg": 71277,
	"./map_device_model_40_focus_off-line.svg": 40737,
	"./map_device_model_40_focus_old-gps.svg": 74609,
	"./map_device_model_40_lock-gps.svg": 49814,
	"./map_device_model_40_new-gps.svg": 7049,
	"./map_device_model_40_off-line.svg": 46538,
	"./map_device_model_40_old-gps.svg": 77712,
	"./map_device_model_500_focus_lock-gps.svg": 74304,
	"./map_device_model_500_focus_new-gps.svg": 14891,
	"./map_device_model_500_focus_off-line.svg": 98624,
	"./map_device_model_500_focus_old-gps.svg": 59446,
	"./map_device_model_500_lock-gps.svg": 82639,
	"./map_device_model_500_new-gps.svg": 87022,
	"./map_device_model_500_off-line.svg": 76223,
	"./map_device_model_500_old-gps.svg": 80871,
	"./map_device_model_50_focus_lock-gps.svg": 1820,
	"./map_device_model_50_focus_new-gps.svg": 9927,
	"./map_device_model_50_focus_off-line.svg": 48788,
	"./map_device_model_50_focus_old-gps.svg": 62738,
	"./map_device_model_50_lock-gps.svg": 29339,
	"./map_device_model_50_new-gps.svg": 87386,
	"./map_device_model_50_off-line.svg": 50755,
	"./map_device_model_50_old-gps.svg": 78275,
	"./mark-red-hover.svg": 15719,
	"./mark-red.svg": 58438,
	"./mark-sos.svg": 43182,
	"./mark-yellow-hover.svg": 62952,
	"./mark-yellow.svg": 60701,
	"./mask_0.svg": 87934,
	"./mask_1.svg": 31663,
	"./member-num.svg": 2554,
	"./menu.svg": 72434,
	"./microphoneP1.svg": 8910,
	"./microphoneP2.svg": 19629,
	"./minus-disable.svg": 66646,
	"./minus.svg": 48441,
	"./mirror.svg": 53994,
	"./misjudged-cancel.svg": 4246,
	"./misjudged-disable.svg": 16156,
	"./misjudged-yellow.svg": 26136,
	"./misjudged.svg": 97703,
	"./mission-note.svg": 64196,
	"./mission.svg": 41039,
	"./missionCheck.svg": 79365,
	"./mode_1_12.svg": 5060,
	"./mode_1_5.svg": 24518,
	"./mode_1x1.svg": 34507,
	"./mode_2_8.svg": 49236,
	"./mode_2x2.svg": 97619,
	"./mode_3x3.svg": 37851,
	"./mode_4x4.svg": 94691,
	"./motor.svg": 38498,
	"./motorcycle-h.svg": 21039,
	"./motorcycle.svg": 68200,
	"./mouse.svg": 21688,
	"./movie.svg": 18737,
	"./multi-checked.svg": 54030,
	"./multi-unchecked.svg": 34421,
	"./mute.svg": 72880,
	"./muteVideo.svg": 785,
	"./new-fr.svg": 31456,
	"./next-disable.svg": 67887,
	"./next.svg": 72396,
	"./nextVideo.svg": 3141,
	"./no-gps.svg": 10237,
	"./no-image.svg": 56754,
	"./no-snapshot.svg": 95899,
	"./no-video.svg": 80768,
	"./note-yellow.svg": 23900,
	"./note.svg": 59667,
	"./notification.svg": 30566,
	"./noun_Police_575220.svg": 50824,
	"./object-scan.svg": 50756,
	"./object.svg": 47482,
	"./on.svg": 58828,
	"./openEye.svg": 19774,
	"./openVolume.svg": 18069,
	"./opened_door.svg": 37079,
	"./page-go-active.svg": 23404,
	"./page-go.svg": 9041,
	"./page_left_arrow.svg": 18360,
	"./page_right_arrow.svg": 67055,
	"./parking-calc.svg": 65845,
	"./patrol-ext_focus_lock-gps.svg": 84259,
	"./patrol-ext_focus_new-gps.svg": 27666,
	"./patrol-ext_focus_off-line.svg": 54075,
	"./patrol-ext_focus_old-gps.svg": 1867,
	"./patrol-ext_focus_sos.svg": 14714,
	"./patrol-ext_lock-gps.svg": 65216,
	"./patrol-ext_new-gps.svg": 35019,
	"./patrol-ext_off-line.svg": 65248,
	"./patrol-ext_old-gps.svg": 98518,
	"./patrol-ext_sos.svg": 43531,
	"./patrol-int_focus_lock-gps.svg": 41297,
	"./patrol-int_focus_new-gps.svg": 91760,
	"./patrol-int_focus_off-line.svg": 9197,
	"./patrol-int_focus_old-gps.svg": 83205,
	"./patrol-int_focus_sos.svg": 87924,
	"./patrol-int_lock-gps.svg": 76618,
	"./patrol-int_new-gps.svg": 57325,
	"./patrol-int_off-line.svg": 18134,
	"./patrol-int_old-gps.svg": 29508,
	"./patrol-int_sos.svg": 64953,
	"./pause.svg": 51947,
	"./pauseVideo.svg": 11760,
	"./pen.svg": 3476,
	"./person-age.svg": 84326,
	"./person-checked.svg": 6004,
	"./person-m.svg": 34718,
	"./person-red-hover.svg": 62631,
	"./person-yellow-hover.svg": 296,
	"./person.svg": 14388,
	"./phone.svg": 16345,
	"./phone_account_calling.svg": 23524,
	"./picture.svg": 75887,
	"./pin-empty.svg": 99412,
	"./pin-not.svg": 89096,
	"./pin.svg": 92528,
	"./pin_s.svg": 6822,
	"./play-video.svg": 22119,
	"./play.svg": 33138,
	"./playVideo.svg": 28550,
	"./plus-disable.svg": 10608,
	"./plus-role.svg": 74044,
	"./plus.svg": 24491,
	"./police-big.svg": 92056,
	"./police-car-chasing.svg": 59012,
	"./police-car-offline.svg": 7274,
	"./police-car.svg": 17128,
	"./police.svg": 67469,
	"./preset.svg": 99070,
	"./prevVideo.svg": 66149,
	"./print-screen.svg": 52733,
	"./ptt.svg": 3185,
	"./ptzCancel.svg": 16753,
	"./ptzClear.svg": 49622,
	"./ptzClearall.svg": 69947,
	"./ptzConfirm.svg": 41637,
	"./ptzPosition.svg": 86894,
	"./ptzPosition_actived.svg": 75653,
	"./ptzPosition_normal.svg": 18592,
	"./ptzText.svg": 9634,
	"./ptzText_actived.svg": 27585,
	"./ptzText_normal.svg": 20324,
	"./public.svg": 91247,
	"./qr_code.svg": 51454,
	"./radio-check.svg": 56251,
	"./recg-preview.svg": 89929,
	"./recognition-yellow.svg": 5717,
	"./recognition.svg": 94668,
	"./refresh-white.svg": 7232,
	"./rightMenuToggle.svg": 58162,
	"./roi-edit.svg": 45952,
	"./roi-lock.svg": 85321,
	"./roi-refresh.svg": 16029,
	"./role_0.svg": 97038,
	"./role_1.svg": 25471,
	"./role_2.svg": 46444,
	"./role_3.svg": 45389,
	"./role_4.svg": 75170,
	"./search.svg": 64343,
	"./server.svg": 65154,
	"./service.svg": 61712,
	"./setting-hover.svg": 59392,
	"./setting.svg": 99941,
	"./show.svg": 15784,
	"./skip-next-disable.svg": 1655,
	"./skip-next.svg": 60964,
	"./snapshot.svg": 20955,
	"./sos-bg-white.svg": 81440,
	"./sos.svg": 97592,
	"./sound.svg": 10168,
	"./source.svg": 4540,
	"./speedometer.svg": 602,
	"./step-down-hover.svg": 37063,
	"./step-down.svg": 24966,
	"./step-left-hover.svg": 87992,
	"./step-left.svg": 42733,
	"./step-right-hover.svg": 72261,
	"./step-right.svg": 4048,
	"./step-up-hover.svg": 67560,
	"./step-up.svg": 11421,
	"./subscription-hover.svg": 60613,
	"./subscription.svg": 36720,
	"./success-check.svg": 80823,
	"./success.svg": 50052,
	"./tag-s.svg": 1685,
	"./tag-yellow.svg": 3410,
	"./tag.svg": 48197,
	"./thumbtack-solid-null.svg": 48310,
	"./thumbtack-solid.svg": 9376,
	"./time-solid.svg": 5334,
	"./time.svg": 75211,
	"./timezone.svg": 78954,
	"./to-arrest-h.svg": 81649,
	"./to-arrest.svg": 63834,
	"./topDownArrow.svg": 72407,
	"./topMenuToggle.svg": 67817,
	"./topUpArrow.svg": 92538,
	"./topbar-setting.svg": 73748,
	"./topbarDown.svg": 51439,
	"./topbarDownDisable.svg": 29905,
	"./topbarUp.svg": 9152,
	"./topbarUpDisable.svg": 85948,
	"./tracking.svg": 64816,
	"./tree-indeterminate-yellow.svg": 78122,
	"./triangle-yellow.svg": 66348,
	"./triangle_left.svg": 4765,
	"./truck.svg": 1964,
	"./tv.svg": 85369,
	"./udid.svg": 21935,
	"./uncheck.svg": 8434,
	"./unknow-user.svg": 16821,
	"./unlink.svg": 23101,
	"./unlive.svg": 7716,
	"./unlocked-gray.svg": 55548,
	"./unlocked.svg": 34360,
	"./unmute.svg": 43445,
	"./urgent-s.svg": 87064,
	"./urgent-white.svg": 38100,
	"./urgent.svg": 82740,
	"./user-astronaut-solid.svg": 16334,
	"./user-calling-bgon.svg": 66904,
	"./user-calling-off.svg": 52757,
	"./user-calling-on.svg": 49217,
	"./user-yellow-L.svg": 49148,
	"./user-yellow.svg": 87167,
	"./user.svg": 10698,
	"./userAccount.svg": 37931,
	"./user_disable.svg": 55135,
	"./user_locked.svg": 24951,
	"./user_pause.svg": 33385,
	"./video-play.svg": 95903,
	"./video.svg": 7680,
	"./view-device.svg": 65763,
	"./vod.svg": 94458,
	"./volume-mute.svg": 1729,
	"./volume-x.svg": 23034,
	"./volume.svg": 21033,
	"./warn-icon.svg": 86299,
	"./warning-red.svg": 55155,
	"./watermark.svg": 76991,
	"./whiteCar.svg": 74252,
	"./windows_icon.svg": 57846,
	"./zoom-in-s.svg": 47878,
	"./zoom-in.svg": 6270,
	"./zoom-in_24x24.svg": 6311,
	"./zoom-out.svg": 98073,
	"./zoom-reset.svg": 95244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17221;